import { DeepRequired, FieldErrorsImpl, Merge, type FieldError, type FieldValues } from "react-hook-form";

export type FormError = {
  hasError: boolean;
  errorMessage?: string;
};

export const retrieveFormError = <T extends FieldValues>(
  error: FieldError | Merge<FieldError, FieldErrorsImpl<DeepRequired<T>[string]>> | undefined,
) => {
  const hasError = !!error;
  const errorMessage = typeof error?.message === "string" ? error.message : "";
  return { hasError, errorMessage };
};
